<template>      
    <div class="w-100 layout">
      <login-header />
      <main>
        <div class="container login-container">
          <slot></slot>
        </div>
      </main>
      <login-footer />
    </div>
</template>

<script>
import loginFooter from "../components/login-footer";
import loginHeader from "../components/login-header";
import appLoading from "../components/app-loading";

export default {
  name: "LoginLayout",
  components: {
    "login-footer": loginFooter,
    "login-header": loginHeader,
    "app-loading": appLoading
  }
};
</script>

<style scoped lang="scss">
main {
  background-color: $white-two-color;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  -webkit-flex-grow: 1;
  width: 100%;
  min-height: 400px;
}

.login-container{
  display: flex;
  flex-direction: column;
}

.layout{
  overflow-y: scroll;
  min-height: 550px;
}
</style>
